/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'./DrillThroughDefinitionHeader',
	'./DrillThroughDefinitionTitleInput',
	'./DrillThroughDefinitionScope',
	'./DrillThroughDefinitionPrompts'
], function (_, $, StringResources, ReactDOM, React, Toolkit, PropTypes, DrillThroughDefinitionHeader, DrillThroughDefinitionTitleInput, DrillThroughDefinitionScope, DrillThroughDefinitionPrompts) {

	const {
		Dialog
	} = Toolkit;

	class DrillThroughDefinitionComponents extends React.Component {

		constructor(props) {
			super(props);
			this.state = {
				...this.props
			};
			this.dialogProps = {
				size: 'large',
				clickaway: false,
				width: '680px'
			};
		}

		/**
		 * Stops the propagation of an event and applies the current drill through manage specification
		 * @param {object} evt
		 */
		_onApply(evt) {
			if (evt) {
				evt.stopPropagation();
			}

			this.props.onOK(this.state);
		}

		/**
		 * Stops the propagation of an event and removes the dialog
		 * @param {object} evt
		 */
		_onCancel(evt) {
			if (evt) {
				evt.stopPropagation();
			}
			this.props.onCancel();
		}

		_getSubTitleText() {
			if (this.props.isLoading) {
				return '';
			} else if (this._isReportPerspective()) {
				return this.props.rowSize ? StringResources.get('drillThroughMappingViewLabel') : StringResources.get('drillThroughDefinitionNoParameterSubTitle');
			} else {
				return StringResources.get('drillthrough_subTitle', {
					perspective: this.props.perspective
				});
			}
		}

		_getDialogTitleText() {
			return this.props.isCreate ? StringResources.get('drillthrough_create_dialogTitle') : StringResources.get('drillthrough_edit_dialogTitle');
		}

		_isReportPerspective() {
			return this.props.type !== 'exploration';
		}

		renderHeader() {
			return ( <DrillThroughDefinitionHeader
				drillDefinitionName={this.props.drillDefinitionName}
				mainTitle={this._getDialogTitleText()}
				subTitle={this._getSubTitleText()}
			/> );
		}

		renderTitleInput() {
			return (<DrillThroughDefinitionTitleInput
				name={this.props.drillDefinitionName}
				handlers={this.props.handlers}
			/>);
		}

		renderRadioScope() {
			return (<DrillThroughDefinitionScope
				checked={this.props.scope}
				onChange={this.props.handlers.onScopeChange}
				applicationName={this.props.applicationName}
			/>);
		}

		renderPrompts() {
			return (
				<DrillThroughDefinitionPrompts
					isLoading={this.state.isLoading}
					iconsFeature={this.props.iconsFeature}
					rowSize={this.state.rowSize}
					isReportPerspective={this._isReportPerspective()}
					parametersTitle={
						this.props.parametersTitle
					}
					metadataTitle={this.props.metadataTitle}
					getRow={this.props.getRow}
					noMappingText = {this.props.noMappingText}
					handlers={this.props.handlers}
				/> );
		}


		componentDidUpdate(prevProps) {
			if (this.props.isLoading !== prevProps.isLoading) {
				this.setState({
					isLoading: this.props.isLoading,
					rowSize: this.props.rowSize
				});
			}
		}

		render() {
			return ( <Dialog {...this.dialogProps}
				onClose={this._onCancel.bind(this)} >
				<Dialog.Body>
					{this.renderHeader()}
					{this.renderTitleInput()}
					{this.renderPrompts()}
					{this.renderRadioScope()}
				</Dialog.Body>
				<Dialog.Footer >
					<Dialog.Button primary id='applyDrillDefinition'
						label={StringResources.get('dlg_apply')}
						title={StringResources.get('dlg_apply')}
						onClick={this._onApply.bind(this)}
					/>
					<Dialog.Button label={StringResources.get('dlg_cancel')}
						title={StringResources.get('dlg_cancel')}
						id='cancelDrillDefinition'
						onClick={this._onCancel.bind(this)}
					/>
				</Dialog.Footer>
			</Dialog>

			);

		}
	}

	DrillThroughDefinitionComponents.propTypes = {
		getRow: PropTypes.func,
		noMappingText: PropTypes.string,
		iconsFeature: PropTypes.object,
		rowSize: PropTypes.number,
		drillDefinitionName: PropTypes.string,
		metadataTitle: PropTypes.string,
		parametersTitle: PropTypes.string,
		isReportPerspective: PropTypes.bool,
		handlers: PropTypes.object,
		onOK: PropTypes.func,
		onCancel: PropTypes.func,
		scope: PropTypes.string,
		isLoading: PropTypes.bool,
		isCreate: PropTypes.bool,
		type: PropTypes.string,
		applicationName: PropTypes.string,
		perspective: PropTypes.string
	};

	return DrillThroughDefinitionComponents;
});